/* 🤖 this file was generated by svg-to-ts */
export const matIconAddLocationAlt: {
  name: 'add-location-alt';
  data: string;
} = {
  name: 'add-location-alt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 1v3h3v2h-3v3h-2V6h-3V4h3V1h2zm-8 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm1-9.94v2.02A6.53 6.53 0 0 0 12 5c-3.35 0-6 2.57-6 6.2 0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.79 6-9.14V11h2v.2c0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 6.22 7.8 3 12 3c.34 0 .67.02 1 .06z"/></svg>`
};
